/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SkeletonText } from '@carbon/react';

var Skeleton = function Skeleton(_ref) {
  var withGradient = _ref.withGradient;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('cpc--banner', {
      'cpc--banner--with-gradient': withGradient
    })
  }, /*#__PURE__*/React.createElement(SkeletonText, null));
};
Skeleton.propTypes = {
  withGradient: PropTypes.bool
};
Skeleton.defaultProps = {
  withGradient: false
};
var Skeleton$1 = Skeleton;

export { Skeleton$1 as default };
